import type { MouseEvent, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Icon } from '../Icon/Icon'
import { cx } from '../utils/cx'
import './QuickHelpRow.css'

export interface QuickHelpRowProps {
  /** Por defecto "¿Necesitáis algo? Ayuda y WhatsApp" */
  label?: ReactNode
  href?: string
  /** Con `href`, el evento permite `preventDefault` para navegar con el router (como Nav) */
  onClick?: (event: MouseEvent<HTMLElement>) => void
  className?: string
}

/** Acceso rápido a Ayuda (bundle B1): fila sunken de 56 px, icono 24 + texto + chevron, fija al final de Tu estancia. */
export function QuickHelpRow({ label, href, onClick, className }: QuickHelpRowProps) {
  const { t } = useTranslation()
  const inner = (
    <>
      <Icon name="life-buoy" size={24} className="hp-quickhelp__icon" />
      <span className="hp-quickhelp__label">{label ?? t('v2.ds.quickHelp.label')}</span>
      <Icon name="chevron-right" size={22} className="hp-quickhelp__chevron" />
    </>
  )
  if (href) {
    return (
      <a href={href} onClick={onClick} className={cx('hp-quickhelp', className)}>
        {inner}
      </a>
    )
  }
  return (
    <button type="button" onClick={onClick} className={cx('hp-quickhelp', className)}>
      {inner}
    </button>
  )
}
